export default {"src":"/_next/static/media/highlight-line.bee1cbe5.svg","height":27,"width":185};